import { useMemo, createContext } from 'react';

import { getNamespacedLogger } from './helpers';
import type { TLoggerContext } from './types';

const DEFAULT_CONTEXT = {
  namespace: 'untagged',
  log: getNamespacedLogger('untagged'),
};
const Context = createContext<TLoggerContext>(DEFAULT_CONTEXT);

function Provider({ namespace, children }: { namespace: string; children: React.ReactNode }) {
  const context = useMemo(
    () => ({
      log: getNamespacedLogger(namespace),
      namespace,
    }),
    [namespace]
  );
  return <Context.Provider value={context}>{children}</Context.Provider>;
}

export { Context };
export default Provider;
